import { IconMoon, IconSun } from '@tabler/icons-react';
import { useContext } from 'react';
import Switch from 'react-switch';

import { colors } from 'constants/colors';
import { darkTheme, lightTheme } from 'constants/theme';
import { getThemePreference, setThemePreference } from 'data/connection/storage';

import { UpdateThemeContext } from 'contexts';

import styled from 'styled-components';

export const ThemeSettings = (): JSX.Element => {
    const { setTheme } = useContext(UpdateThemeContext);
    const themeFromStorage = getThemePreference();

    const updateTheme = (): void => {
        if (themeFromStorage === 'dark') {
            setThemePreference('light');
            setTheme(lightTheme);
        } else {
            setThemePreference('dark');
            setTheme(darkTheme);
        }
    };

    return (
        <>
            <SectionTitle>Apparence</SectionTitle>
            <Switch
                onChange={updateTheme}
                checked={themeFromStorage !== 'dark'}
                onColor={colors.green}
                offColor={colors.pantinGrey}
                onHandleColor={colors.pureWhite}
                offHandleColor="#282c34"
                checkedIcon={false}
                uncheckedIcon={false}
                checkedHandleIcon={
                    <IconContainer>
                        <IconSun color={colors.black} />
                    </IconContainer>
                }
                uncheckedHandleIcon={
                    <IconContainer>
                        <IconMoon color={colors.lightGrey} />
                    </IconContainer>
                }
            />
        </>
    );
};

const SectionTitle = styled.h3`
    color: ${({ theme }) => theme.textColor};
    margin-top: 20px;
    margin-bottom: 5px;
    font-size: 16px;
`;

const IconContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`;
